import React from 'react';
import { Icon } from '@workboard/action-item';
import { getAiTypeAttributes } from '../../utils';
import { AiTypeIconProps } from './types';

export function AiTypeIcon ({
  type,
  size,
}: AiTypeIconProps) {
  const { icons } = getAiTypeAttributes(type);

  return (
    <Icon
      name={icons?.component}
      width={size?.toString()}
      height={size?.toString()}
    />
  );
}
